// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationModalBackButtonContainer {
    display: flex;
    justify-content: right;
    padding: 4px;
}

.notificationModalImageContainer {
    display: flex;
    justify-content: center;
}

.notificationImageLoaderImageDisplay {
    display: inline-block;
    max-height: 10em;
    max-width: 15em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.notificationContainerContent {
    text-align: center;
}

.notificationModalBackButton {
    color: white;
    border: none;
    outline: none;
    background-color: var(--templatesColorBackgroundContainer);
    cursor: pointer;
}

.notificationModalBackButton:hover {
    background-color: var(--templatesColorBackgroundInContainer);
}

.notificationModalTitle {
    text-align: center;
}

.notificationModalLineBreak {
    height: 3px;
    background-color: var(--templatesColorBackgroundInContainer);
    border: none;
}

.notificationModalMessageContent {
    text-align: center;
    word-break: break-word;
}

.notificationModalContent p,
a {
    color: gray;
}

.notificationModalOverLayContainerWrapper {
    position: fixed;
    top: 0;
    /* position the top  edge of the element at the middle of the parent */
    left: 0;
    /* position the left edge of the element at the middle of the parent */
    z-index: 40;
    width: 100%;
    height: 100%;
    overflow: auto;
    backdrop-filter: blur(3px) contrast(99%) grayscale(1);
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

.notifcationContainerAnimation {
    animation: popup 0.5s normal forwards ease-in-out;
}

.notificationContainerContent {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.notificationModalLeftButton {
    display: inline-block;
    padding: 0.5em;
}

.notificationModalRightButton {
    display: inline-block;
}

.notificationModalBlur {
    pointer-events: none;
}

.notificationModalLogoDude {
    max-width: 5em;
    position: absolute;
    left: 4em;
    top: 3em;
    opacity: 0.3;
}

@media only screen and (max-width: 768px) {
    .notificationModalLogoDude {
        top: 2em;
        left: 2em;
    }

    .notificationImageLoaderImageDisplay {
        max-height: 9em;
    }
}

@media screen and (max-width: 320px) {
    .notificationImageLoaderImageDisplay {
        max-height: 8em;
        max-width: 15em;
    }
}

@keyframes popup {
    0% {
        transform: scale(0, 1);
    }

    100% {
        transform: scale(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/NotificationModal/notificationModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0DAA0D;IAC1D,eAAe;AACnB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,MAAM;IACN,sEAAsE;IACtE,OAAO;IACP,sEAAsE;IACtE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qDAAqD;IACrD,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".notificationModalBackButtonContainer {\n    display: flex;\n    justify-content: right;\n    padding: 4px;\n}\n\n.notificationModalImageContainer {\n    display: flex;\n    justify-content: center;\n}\n\n.notificationImageLoaderImageDisplay {\n    display: inline-block;\n    max-height: 10em;\n    max-width: 15em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.notificationContainerContent {\n    text-align: center;\n}\n\n.notificationModalBackButton {\n    color: white;\n    border: none;\n    outline: none;\n    background-color: var(--templatesColorBackgroundContainer);\n    cursor: pointer;\n}\n\n.notificationModalBackButton:hover {\n    background-color: var(--templatesColorBackgroundInContainer);\n}\n\n.notificationModalTitle {\n    text-align: center;\n}\n\n.notificationModalLineBreak {\n    height: 3px;\n    background-color: var(--templatesColorBackgroundInContainer);\n    border: none;\n}\n\n.notificationModalMessageContent {\n    text-align: center;\n    word-break: break-word;\n}\n\n.notificationModalContent p,\na {\n    color: gray;\n}\n\n.notificationModalOverLayContainerWrapper {\n    position: fixed;\n    top: 0;\n    /* position the top  edge of the element at the middle of the parent */\n    left: 0;\n    /* position the left edge of the element at the middle of the parent */\n    z-index: 40;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    backdrop-filter: blur(3px) contrast(99%) grayscale(1);\n    background-color: rgb(0, 0, 0);\n    /* Fallback color */\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Black w/ opacity */\n}\n\n.notifcationContainerAnimation {\n    animation: popup 0.5s normal forwards ease-in-out;\n}\n\n.notificationContainerContent {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n.notificationModalLeftButton {\n    display: inline-block;\n    padding: 0.5em;\n}\n\n.notificationModalRightButton {\n    display: inline-block;\n}\n\n.notificationModalBlur {\n    pointer-events: none;\n}\n\n.notificationModalLogoDude {\n    max-width: 5em;\n    position: absolute;\n    left: 4em;\n    top: 3em;\n    opacity: 0.3;\n}\n\n@media only screen and (max-width: 768px) {\n    .notificationModalLogoDude {\n        top: 2em;\n        left: 2em;\n    }\n\n    .notificationImageLoaderImageDisplay {\n        max-height: 9em;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .notificationImageLoaderImageDisplay {\n        max-height: 8em;\n        max-width: 15em;\n    }\n}\n\n@keyframes popup {\n    0% {\n        transform: scale(0, 1);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
